<template>
    <div class="header-toolbar">
        <div class="cancel-button" @click="leftClickEvent">{{ leftTitle }}</div>
        <div class="title">{{ title }}</div>
        <div class="post-button" @click="rightClickEvent">{{ rightTitle }}</div>
    </div>
</template>

<script>
    export default {
        name: "ButtonHeader",
        props: {
            leftTitle: String,
            title: String,
            rightTitle: String
        },
        data() {
            return {
            }
        },
        methods: {
            leftClickEvent() {
                this.$emit("leftClickEvent");
            },
            rightClickEvent() {
                this.$emit("rightClickEvent");
            }
        }
    }
</script>

<style scoped lang="scss">
    div.header-toolbar {
        padding: 0 24px;
        height: 56px;
        background-color: white;
        border-bottom: 1px solid $line-third-color;

        display: flex;
        justify-content: space-between;
        align-items: center;

        div.cancel-button {
            height: 22px;
            padding: 0 8px;
            border: 1px solid $font-fourth-color;
            border-radius: 22px;
            line-height: 20px;
            text-align: center;
            font-size: $font-base12;
            font-weight: $font-weight500;
            color: $font-fourth-color;
        }
        div.title {
            flex: 1;
            text-align: center;
            font-size: $font-base18;
            font-weight: $font-weight500;
        }
        div.post-button {
            height: 22px;
            padding: 0 8px;
            border: 1px solid $primary-color;
            border-radius: 22px;
            line-height: 20px;
            text-align: center;
            font-size: 11px;
            font-weight: $font-weight500;
            color: $primary-color;
        }
    }
</style>
